<template>
   <div class="gts-switch-wrapper">
      <input @change="triggerSwitchChange" :id="uniqueId" type="checkbox" class="switch-checkbox" :disabled="disabled" />
      <span v-if="$slots['switch-left-text']" class="switch-left-text">
         <slot name="switch-left-text"></slot>
      </span>
      <label :for="uniqueId" class="switch-label" :class="isSwitchActive ? 'is-active' : 'is-deactive'" :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }">
         <div class="switch-toggle" :class="isSwitchActive ? 'is-active' : 'is-deactive'"></div>
      </label>
      <span v-if="$slots['switch-right-text']" class="switch-right-text">
         <slot name="switch-right-text"></slot>
      </span>
   </div>
</template>

<script>
export default {
   name: "UISwitch",
   props: {
      switchInitStatus: { type: Boolean },
      uniqueId: { type: String, default: "switch" },
      disabled: { type: Boolean, default: false },
   },
   data() {
      return {
         isSwitchActive: false,
      };
   },
   methods: {
      triggerSwitchChange() {
         if (this.disabled) return;
         const self = this;
         self.isSwitchActive = !self.isSwitchActive;
         this.$emit("update-switch-status", self.isSwitchActive);
      },
   },
   created() {
      const self = this;

      self.isSwitchActive = this.switchInitStatus;
      this.$emit("update-switch-status", self.isSwitchActive);
   },
   watch: {
      switchInitStatus(newStatus) {
         const self = this;
         self.isSwitchActive = newStatus;
      },
   },
};
</script>

<style lang="scss" scoped>
.gts-switch-wrapper {
   display: flex;
   align-items: center;

   & > span {
      &.switch-left-text {
         margin-right: 8px;
      }
      &.switch-right-text {
         margin-left: 8px;
      }
   }

   .switch-checkbox {
      display: none;
   }

   .switch-label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      width: 70px;
      padding: 4px;
      border: 1px solid;
      border-radius: 50px;
      transition: background 0.3s ease;
      cursor: pointer;
      z-index: 1;

      &.is-active {
         background: var(--blue-300);
         border-color: var(--blue-300);
      }
      &.is-deactive {
         background-color: var(--surface-level-1);
         border-color: var(--gray-300);
      }
   }

   .switch-toggle {
      width: 24px;
      height: 24px;
      background-color: var(--surface-level-1);
      border-radius: 50%;
      transform: translateX(0);
      transition: transform 0.3s ease, background-color 0.5s ease;

      &.is-active {
         transform: translateX(38px);
      }
      &.is-deactive {
         background-color: var(--gray-300);
      }
   }

   .switch-label[style*="not-allowed"] {
      opacity: 0.6;
   }
}
</style>
